export const checkFileAccept = (acceptString, file) => {
    if (!acceptString) {
        return true;
    }
    const acceptStringList = acceptString
        ? acceptString
            .toLowerCase()
            .split(',')
            .map((str) => str.trim())
        : [];
    const mime = (file.type || '').toLowerCase();
    const name = (file.name || '').toLowerCase();
    return acceptStringList.some((accept) => {
        if (accept.startsWith('.')) {
            return name.endsWith(accept);
        }
        if (accept.endsWith('/*')) {
            return mime.startsWith(accept.slice(0, -1));
        }
        return mime === accept;
    });
};
//# sourceMappingURL=utils.js.map